import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useCookieConsent } from "../contexts/CookieConsentContext";

const GA_MEASUREMENT_ID = "G-E1MDF7CX09";

const ensureGoogleAnalytics = (hasConsent) => {
  // Only initialize if user has given consent
  if (!hasConsent || typeof window === "undefined" || !GA_MEASUREMENT_ID) {
    return false;
  }

  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  if (!document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}"]`)) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }

  if (!window.__gaInitialized) {
    window.gtag("js", new Date());
    window.gtag("config", GA_MEASUREMENT_ID, {
      send_page_view: false,
    });
    window.__gaInitialized = true;
  }

  return true;
};

const GaAnalytics = () => {
  const location = useLocation();
  const { hasConsent } = useCookieConsent();

  useEffect(() => {
    if (!ensureGoogleAnalytics(hasConsent)) {
      return;
    }

    const pagePath = `${location.pathname}${location.search}${location.hash}`;

    window.gtag("event", "page_view", {
      page_title: document.title,
      page_location: window.location.href,
      page_path: pagePath,
      send_to: GA_MEASUREMENT_ID,
    });
  }, [location, hasConsent]);

  return null;
};

export default GaAnalytics;
